import { SettingsObject } from '@hooks/useSettings';

export const localhost: Partial<SettingsObject> = {
    // we don't have Akamai redirects in localhost so we still want to use favourites
    urlBaseName: 'favourites',
};
